import React from "react";

import styles from "../CouponForm.module.scss";

const CouponFormToggleSwitch = ({ checked, onChange, disabled = false }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    className={`${styles.toggle} ${checked ? styles.toggleOn : ""}`}
    onClick={() => !disabled && onChange(!checked)}
    disabled={disabled}
  >
    <span className={styles.toggleThumb} />
  </button>
);

export default CouponFormToggleSwitch;
